import React from 'react'
import { H2 } from './styles'
import { theme } from '../../theme/theme'

const TitleDrawer = ({ title }) => {
  return <H2 style={{ color: theme.text.primary.main }}>{title}</H2>
}

export default TitleDrawer
